/**
 * Build-time flag. Set REACT_APP_API_MOCK=1 when starting the admin for e2e.
 * Production builds never enable the mock (see isEnabled.js).
 */
export const USE_API_MOCK = process.env.REACT_APP_API_MOCK === '1';
